export default "__VITE_PUBLIC_ASSET__8652d425__"